/**
 * PDF文档存储服务
 * 实现IPdfDocumentStorageService接口，通过PdfDocumentStorageProvider提供PDF文档存储功能
 */
import { PdfDocumentStorageProvider } from '@readsavor/utils';
import { LoggerService } from '../../logging/services/logger.service.js';
/**
 * PDF文档存储服务
 * 实现IPdfDocumentStorageService接口，处理业务逻辑
 */
export class PdfStorageService {
    constructor() {
        this.logger = LoggerService.getInstance();
        this.provider = PdfDocumentStorageProvider.getInstance();
    }
    static getInstance() {
        if (!PdfStorageService.instance) {
            PdfStorageService.instance = new PdfStorageService();
        }
        return PdfStorageService.instance;
    }
    async initialize() {
        await this.provider.initialize();
    }
    async getDocument(identity) {
        return this.getPdfDocument(identity);
    }
    async addDocument(document) {
        return this.provider.addDocument(document);
    }
    async getPdfDocument(identity) {
        return this.provider.getDocument(identity);
    }
    async getAllDocumentsMetadata() {
        return this.provider.getAllDocumentsMetadata();
    }
    async getReadingPosition(identity) {
        const doc = await this.provider.getDocument(identity);
        if (!doc) {
            return undefined;
        }
        const position = {
            anchor: doc.readingAnchor?.anchor || { index: 0, offset: 0 },
            percentage: doc.lastReadPercentage || 0,
            scale: doc.lastReadScale ?? 1.0,
        };
        return position;
    }
    async updateReadingPosition(identity, position) {
        await this.provider.updateDocument(identity, {
            readingAnchor: position,
            lastReadPercentage: position.percentage,
            lastReadScale: position.scale,
            lastAccessTime: Date.now(),
        });
    }
    async getVirtualizationCache(identity) {
        const pageInfos = await this.provider.getPageInfos(identity.id);
        const cache = new Map();
        pageInfos.forEach((info) => {
            if (info.height !== undefined) {
                cache.set(info.pageIndex, info.height);
            }
        });
        return cache;
    }
    async updateVirtualizationCache(identity, cache) {
        const pageInfosToUpdate = Array.from(cache.entries()).map(([pageIndex, height]) => ({
            documentId: identity.id,
            pageIndex,
            width: 0,
            height,
        }));
        if (pageInfosToUpdate.length > 0) {
            await this.provider.bulkUpdatePageInfos(pageInfosToUpdate);
        }
    }
    async deleteDocument(identity) {
        await this.provider.deleteDocument(identity);
    }
    async getStats() {
        const count = await this.provider.getDocumentCount();
        return { documentCount: count };
    }
}
PdfStorageService.instance = null;
//# sourceMappingURL=PdfStorageService.js.map